import React from 'react';
import styled from 'styled-components';

const NoRowsContainer = styled.div`
  padding: 2.5rem;
  text-align: center;
  font-size: 0.875rem;
  color: #666;
`;

interface NoRowsOverlayProps {
  message: string;
}

export const NoRowsOverlay: React.FC<NoRowsOverlayProps> = ({ message }) => (
  <NoRowsContainer>{message}</NoRowsContainer>
);
